import React from 'react';
import { lang } from '../../lang';
import { useTranslation } from 'react-i18next';

function Statement() {
    const { t, i18n } = useTranslation();
    return (
        <div className={`center-statement ${i18n.language === 'en' ? 'en-center-statement' : ''}`}>
            <div
                className={`statement-text ${
                    i18n.language === 'en' ? 'text-left en-statement-text' : ''
                }`}
            >
                <h1>{t('ace')}</h1>
                <h5>{t('who.statement')}</h5>
                <ul>
                    <li>{t('who.s1')}</li>
                    <li>{t('who.s2')}</li>
                    <li>{t('who.s3')}</li>
                    <li>{t('who.s4')}</li>
                    <li>{t('who.s5')}</li>
                </ul>
            </div>
        </div>
    );
}

export default Statement;
